import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { EditorState, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

class UserAgreementModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };

    this.agreementContentHtml = this.agreementContentHtml.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { message} = this.props;
    if (prevProps.message !== message) {
      this.agreementContentHtml(message);
    }
  }

  agreementContentHtml = value => {
    
    const html = value;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      this.setState({
        editorState: EditorState.createWithContent(contentState),
      });
    }
  };

  onEditorStateChange = editorState => {
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCloseClick}
          centered={true}
          size="xl"
        >
          <ModalBody>
            <Row>
              <Col xl={12} lg={12}>
                <div>
                  <h5>
                    {" "}
                    <i
                      className="bx bx-info-circle"
                      style={{
                        marginRight: "3px",
                        marginTop: "-4px",
                        fontSize: "1.5em",
                        color: "orange",
                      }}
                    />
                    {this.props.title}
                  </h5>
                </div>
                <div className="modal-body">
                  <div>
                    <Editor
                      name={"agreementContent"}
                      editorStyle={{
                        minHeight: "500px",
                      }}
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      onEditorStateChange={this.onEditorStateChange}
                      toolbarHidden={true}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <ModalHeader style={{ marginBottom: "10px" }}></ModalHeader>
            <Row>
              <Col lg={12}>
                <div style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    className="btn btn-secondary me-1"
                    onClick={this.props.onCloseClick}
                  >
                    {this.props.t("ok")}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

UserAgreementModal.propTypes = {
  onCloseClick: PropTypes.func,
  message: PropTypes.any,
  title: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(UserAgreementModal);
